import React, { useEffect, useState } from "react";
import moment from "moment";
import { connect } from "react-redux";
// icons
import { HiChatBubbleLeftRight } from "react-icons/hi2";
import { AiFillInstagram } from "react-icons/ai";
import { MdEmail } from "react-icons/md";
import { BsTwitterX } from "react-icons/bs";
import { RiRobot2Fill, RiWhatsappFill } from "react-icons/ri";
import { FaVideo, FaPhone, FaFacebookF } from "react-icons/fa6";
// import Tooltip from "@mui/material/Tooltip";
import { UserSwitch, UsersThree } from "@phosphor-icons/react";
// mui
import Tooltip from "@mui/material/Tooltip";
import {
  Skeleton,
  Typography,
  Stack,
  Badge,
  Box,
  Avatar,
  Grid,
  MenuItem,
  ListItemIcon,
  Menu,
  ListItemText,
  Backdrop,
  CircularProgress,
} from "@mui/material";
// other
import {
  EndChat,
  setShowEndChatBackDropSpinner,
} from "../../../../Redux/Actions/actions";

import { RiCloseCircleFill } from "react-icons/ri";
import { BiTransferAlt } from "react-icons/bi";
import { RiMailCloseFill } from "react-icons/ri";
import { MdOutlineWarning } from "react-icons/md";
import { randomColors } from "../../../../Utils/colorpallet";
import { styled } from "@mui/material/styles";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const StyledBadge2 = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#E91E63",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
  },
}));

const StyledBadgeCount = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#E91E63",
    color: "#FFFF",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    top: "3px",
    left: "3px",
    "&::after": { animation: "none", border: "none" },
  },
}));

const mapStateToProps = (state) => {
  const { data, contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
    contactList: contactListData.contactList,
    cannedmessagediv: data.cannedmessagediv,
    contactlistLoader: contactListData.contactlistLoader,
    showEndChatBackDropSpinner: contactListData.showEndChatBackDropSpinner,
    callList: state.voice.callList,
  };
};
const ExternalContactList = (props) => {
  const { externalChat, contact, index } = props;
  const [anchorEl, setAnchorEl] = useState(null);
  const [clickedChat, setclickedChat] = useState();
  const [currentTime, setCurrentTime] = useState(moment());

  const formatTime = (lastmessagetime) => {
    if (lastmessagetime) {
      const messageTime = moment(lastmessagetime, "hh:mm:A");
      const diffMinutes = currentTime.diff(messageTime, "minutes");

      if (diffMinutes < 1) {
        return "just now";
      } else if (diffMinutes < 60) {
        return `${diffMinutes}m`;
      } else if (diffMinutes < 120) {
        const diffHours = Math.floor(diffMinutes / 60);
        const remainingMinutes = diffMinutes % 60;
        return `${diffHours}hr ${remainingMinutes}m`;
      } else if (diffMinutes < 1440) {
        const diffHours = Math.floor(diffMinutes / 60);
        return `${diffHours} ${diffHours === 1 ? "hr" : "hrs"} ago`;
      } else if (diffMinutes < 2880) {
        return "yst";
      } else {
        const diffDays = Math.floor(diffMinutes / 1440);
        return `${diffDays} ${diffDays === 1 ? "day" : "days"} ago`;
      }
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment());
    }, 60000);

    return () => clearInterval(interval);
  }, []);

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const isMatchingCall = props.callList?.some(
    (calllist) => contact?.voice_contactId == calllist?.contactId,
  );

  const name = (contact) => {
    if (!contact) return;
    if (contact.channel === "voice") {
      return contact.unique_id.phonenumber
        ? contact.unique_id.phonenumber.slice(0, 2)
        : "NA";
    } else if (contact.channel === "email") {
      return contact.unique_id.email
        ? contact.unique_id.email.slice(0, 2).toUpperCase()
        : "NA";
    } else {
      return contact.unique_id.username
        ? contact.unique_id.username.slice(0, 2).toUpperCase()
        : "NA";
    }
  };

  return (
    <>
      <div
        aria-describedby={id}
        className={
          props.externalChatData
            ? props.externalChatData.id == contact.id
              ? "d-flex chat-active"
              : "chat-contact d-flex"
            : "chat-contact d-flex"
        }
        onClick={(e) => {
          externalChat(contact);
        }}
        onContextMenu={(event) => {
          event.preventDefault();
          if (isMatchingCall) return;
          setclickedChat(contact);
          handleClick(event);
        }}
        style={{
          cursor: "pointer",
          width: "100%",
          userSelect: "none",
          padding: "5px 5px",
          marginBottom: "2px",
        }}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={0.5}
          sx={{ width: "100%", height: "100%" }}
        >
          <Box className="position-relative">
            {/* user profile  */}
            {props.contactlistLoader ? (
              <Skeleton
                animation="wave"
                variant="circular"
                width={35}
                height={35}
              />
            ) : (
              <>
                {(() => {
                  switch (contact.channel) {
                    case "webchat":
                    case "from_whatsapp":
                    case "from_purple":
                    case "videochat":
                      return (
                        <>
                          {contact.is_customer_disconnected === true ? (
                            <StyledBadge2
                              overlap="circular"
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              variant="dot"
                            >
                              <Avatar
                                className="box-inset2 position-relative"
                                sx={{
                                  background: randomColors[index],
                                  height: "35px",
                                  width: "35px",
                                  fontSize: "12px",
                                  fontWeight: 600,
                                  border: "2px solid white",
                                }}
                              >
                                {name(contact)}
                              </Avatar>
                            </StyledBadge2>
                          ) : (
                            <StyledBadge
                              overlap="circular"
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "right",
                              }}
                              variant="dot"
                            >
                              <StyledBadgeCount
                                max={10}
                                badgeContent={contact.unreadcount}
                                anchorOrigin={{
                                  vertical: "top",
                                  horizontal: "left",
                                }}
                              >
                                <Avatar
                                  className="box-inset2 position-relative"
                                  sx={{
                                    background: randomColors[index],
                                    height: "35px",
                                    width: "35px",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    border: "2px solid white",
                                  }}
                                >
                                  {name(contact)}
                                </Avatar>
                              </StyledBadgeCount>
                            </StyledBadge>
                          )}
                        </>
                      );

                    default:
                      return (
                        <Avatar
                          className="box-inset2 position-relative"
                          sx={{
                            background: randomColors[index],
                            height: "35px",
                            width: "35px",
                            fontSize: "12px",
                            fontWeight: 600,
                          }}
                        >
                          {name(contact)}
                        </Avatar>
                      );
                  }
                })()}
              </>
            )}
          </Box>

          <Box
            sx={{
              width: "100%",
              height: "100%",
            }}
          >
            <Stack
              direction={"row"}
              justifyContent={"start"}
              alignItems={"center"}
            >
              <Stack
                direction={"row"}
                alignItems={"center"}
                justifyContent={"space-between"}
                className="w-100"
              >
                {props.contactlistLoader ? (
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={100}
                    height={10}
                  />
                ) : (
                  <>
                    <Grid container>
                      <stack className="col-9" width={60} wrap="nowrap">
                        <Grid item xs zeroMinWidth sx={{ width: "9em" }}>
                          <Typography
                            noWrap
                            sx={{
                              color:
                                props.externalChatActive == contact.id
                                  ? "white"
                                  : "#0b3363",
                              fontSize: "13px",
                              fontWeight: "bold",
                            }}
                          >
                            {contact.channel === "email"
                              ? contact.email
                              : contact.unique_id.username
                                ? contact.unique_id.username
                                : contact.unique_id.phonenumber}
                          </Typography>
                        </Grid>
                      </stack>
                      <stack className="col-3 d-flex align-items-center justify-content-end gap-1">
                        {/* channel  */}
                        {contact.channel === "webchat" ? (
                          <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                            <HiChatBubbleLeftRight size={10} />
                          </div>
                        ) : contact.channel === "instagram" ? (
                          <div className="inst-bg chat-social d-flex justify-content-center align-items-center">
                            <AiFillInstagram size={10} />
                          </div>
                        ) : contact.channel === "from_whatsapp" ? (
                          <div className="what-bg chat-social d-flex justify-content-center align-items-center">
                            <RiWhatsappFill size={10} />
                          </div>
                        ) : contact.channel === "voice" ? (
                          <div className="what-bg chat-social d-flex justify-content-center align-items-center">
                            <FaPhone size={10} />
                          </div>
                        ) : contact.channel === "from_facebook" ? (
                          <div className="fb-bg chat-social d-flex justify-content-center align-items-center">
                            <FaFacebookF size={10} />
                          </div>
                        ) : contact.channel === "from_twitter" ? (
                          <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                            <BsTwitterX size={10} />
                          </div>
                        ) : contact.channel === "email" ? (
                          <div
                            className="twit-bg chat-social d-flex justify-content-center align-items-center"
                            style={{ background: "" }}
                          >
                            <MdEmail size={10} />
                          </div>
                        ) : contact.channel === "from_purple" ? (
                          <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                            <RiRobot2Fill size={10} />
                          </div>
                        ) : (
                          <div className="twit-bg chat-social d-flex justify-content-center align-items-center">
                            <FaVideo size={10} />
                          </div>
                        )}

                        {/* Transferred/Conferance  */}
                        {props.contactlistLoader ? (
                          <Skeleton
                            animation="wave"
                            variant="rectangular"
                            width={20}
                            height={20}
                          />
                        ) : (
                          <span
                            className="d-flex"
                            style={{ flexDirection: "column" }}
                          >
                            {contact.conference ? (
                              <Tooltip
                                title="Conferance Interaction"
                                arrow
                                placement="right"
                              >
                                <UsersThree
                                  size={15}
                                  weight="fill"
                                  sx={{ color: "#0b3363" }}
                                />
                              </Tooltip>
                            ) : null}
                            {contact.transferred ? (
                              <Tooltip
                                title="Transferred Interaction"
                                arrow
                                placement="right"
                              >
                                <UserSwitch
                                  size={15}
                                  weight="fill"
                                  spacing={1}
                                  sx={{ color: "#0b3363" }}
                                />
                              </Tooltip>
                            ) : null}
                          </span>
                        )}
                      </stack>
                    </Grid>
                  </>
                )}
              </Stack>
            </Stack>

            <Stack
              direction={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Stack className="col-8">
                {props.contactlistLoader ? (
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={60}
                    height={10}
                    sx={{ marginTop: "10px" }}
                  />
                ) : (
                  <Typography
                    variant="caption"
                    noWrap
                    sx={{
                      fontSize: "12px",
                      color:
                        props.externalChatActive == contact.id
                          ? "white"
                          : "#868585",
                      maxWidth: "8rem",
                    }}
                  >
                    {contact.lastmessage}
                  </Typography>
                )}
              </Stack>
              <Stack
                className="col-4"
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
                spacing={0.5}
              >
                {props.contactlistLoader ? (
                  <Skeleton
                    animation="wave"
                    variant="rectangular"
                    width={30}
                    height={10}
                  />
                ) : (
                  <Typography
                    variant="caption"
                    sx={{
                      fontSize: "10px",
                      color:
                        props.externalChatActive == contact.id
                          ? "white"
                          : "#868585",
                    }}
                  >
                    {formatTime(contact.lastmessagetime)}
                  </Typography>
                )}
              </Stack>
            </Stack>
          </Box>
        </Stack>
      </div>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "center",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            background: "#1c1c1c",
            color: "white",
          },
        }}
      >
        <MenuItem
          sx={{
            ":hover": {
              background: "#3f3f3f",
            },
          }}
          onClick={() => {
            props.setShowEndChatBackDropSpinner(true);
            props.EndChat(clickedChat);
            handleClose();
          }}
        >
          <ListItemIcon>
            <RiCloseCircleFill size={16} color="#FFFF" />
          </ListItemIcon>
          <ListItemText sx={{ ".MuiTypography-root": { fontSize: "11px" } }}>
            End interaction
          </ListItemText>
        </MenuItem>
      </Menu>

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={props.showEndChatBackDropSpinner}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default connect(mapStateToProps, {
  EndChat,
  setShowEndChatBackDropSpinner,
})(ExternalContactList);
